import React, { useEffect, useState } from "react";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { useNavigate } from "react-router-dom";
import { DbBackupApi, DeleteUser, GetAllUsers } from "../../api";
import { Header, Button } from "../../components";
import "../../styles/viewCustomer.css";
import { useStateContext } from "../../contexts/ContextProvider";
import { Col, Container, Row } from "react-bootstrap";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import {
  showSuccessToast,
  showErrorToast,
  showInfoToast,
} from "../../components/ToastMesg";
import DataGrid from "../../components/DataGrid";

const Users = () => {
  const navigate = useNavigate();
  const { userPermID } = useStateContext();
  const [AllUsers, setAllUsers] = useState([]);
  const [User_id, setUser_id] = useState("");
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(false);

  const usersGrid = [
    {
      field: "username",
      headerText: "Username",
      minWidth: "180",
      width: "260",
      maxWidth: "340",
      textAlign: "left",
    },
    {
      field: "role",
      headerText: "Role",
      minWidth: "140",
      width: "180",
      maxWidth: "200",
      textAlign: "left",
    },
    {
      field: "role_desc",
      headerText: "Role Description",
      minWidth: "200",
      width: "360",
      maxWidth: "560",
      textAlign: "left",
    },
    {
      field: "company",
      headerText: "Company",
      minWidth: "200",
      width: "360",
      maxWidth: "560",
      textAlign: "left",
    },
    {
      field: "last_login",
      headerText: "Last Login",
      type: "datetime",
      format: "dd/MM/yyyy HH:mm",
      minWidth: "240",
      width: "250",
      maxWidth: "280",
      textAlign: "center",
    },
  ];

  const handleRowSelected = (args) => setUser_id(args.data.user_id);

  const handleAddUserClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    navigate(`/Users/AddUser`);
  };

  const handleEditUserClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    if (User_id === 100)
      showInfoToast("Info!", "This User is Master Admin and cannot be edited!");
    else if (User_id !== "") navigate(`/Users/EditUser/${User_id}`);
    else showInfoToast("Info!", "Please select user to edit!");
  };

  const handleDeleteUserClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      if (User_id !== "") {
        if (User_id === 100)
          showInfoToast(
            "Info!",
            "This User is Master Admin and cannot be deleted!",
          );
        else {
          if (window.confirm(`Are you sure you want to Delete this User?`)) {
            const response = await DeleteUser(User_id);
            if (response.success) {
              showSuccessToast("Success!", "User deleted successfully!");
              window.location.reload();
            } else
              showErrorToast(
                "Error!",
                "User failed to delete: " + response.message,
              );
          }
        }
      } else showInfoToast("Info!", "Please select User to delete!");
    } catch (error) {
      showErrorToast("Error!", "User failed to delete!");
    }
  };

  const handleCompanyClick = () => {
    TimeoutUtility.resetTimeout();
    navigate(`/Users/AddEditCompany`);
  };

  const handleSONoteClick = () => {
    TimeoutUtility.resetTimeout();
    navigate(`/Users/AddEditSaleOrderNote`);
  };

  const handleBackupClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      if (window.confirm(`Are you sure you want to create database Backup?`)) {
        const response = await DbBackupApi();
        if (response.substring(0, 5) !== "Error")
          showSuccessToast("Success!", "Backup created successfully!");
        else showErrorToast("Error!", "Backup failed!\n\n" + response);
      }
    } catch (error) {
      showErrorToast("Error!", "Backup failed!");
    }
  };

  const handleViewUserClick = () => {
    TimeoutUtility.resetTimeout();
    if (User_id !== "") navigate(`/Users/ViewUser/${User_id}`);
    else showInfoToast("Info!", "Please select user to view!");
  };

  const handleRefresh = async () => {
    const resp = await GetAllUsers();
    setAllUsers(resp.data || []);
  };

  useEffect(() => {
    async function fetchData() {
      setloading(true);
      trackPromise(
        GetAllUsers()
          .then((result) => setAllUsers(result.data || []))
          .catch((err) => console.log(err.message))
          .finally(() => setloading(false)),
      );
    }
    fetchData();
    // const interval = setInterval(fetchData, 5000); // every 5 sec
    // return () => clearInterval(interval);
  }, []);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header category="Admin" title="USERS" />
      <Container fluid className="g-0 p-0 justify-end">
        <Row xs={2} className="button-row justify-content-end font-normal">
          {userPermID.includes(41) && (
            <Col md="auto p-0">
              <Button text="Add" onClick={handleAddUserClick} />
            </Col>
          )}
          {userPermID.includes(42) && (
            <>
              <Col md="auto p-0">
                <Button text="Update" onClick={handleEditUserClick} />
              </Col>
              <Col md="auto p-0">
                <Button text="Delete" onClick={handleDeleteUserClick} />
              </Col>
              <Col md="auto p-0">
                <Button text="Update Company" onClick={handleCompanyClick} />
              </Col>
              <Col md="auto p-0">
                <Button text="Update SO Note" onClick={handleSONoteClick} />
              </Col>
              <Col md="auto p-0">
                <Button text="Backup" onClick={handleBackupClick} />
              </Col>
            </>
          )}
        </Row>
      </Container>
      <DataGrid
        loading={loading || promiseInProgress}
        data={AllUsers}
        cols={usersGrid}
        handleRowSelected={handleRowSelected}
        handleDoubleClick={userPermID.includes(40) && handleViewUserClick}
        persistant={true}
        handleRefresh={handleRefresh}
      />
    </div>
  );
};

export default Users;
